const author = (state = "", action) => {
    switch(action.type) {
        case 'author':
            return action.payload;
        default:
            return state;
    }
}

export default author;